import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { AddexpensetypeComponent } from '../../expensetype/addexpensetype/addexpensetype.component';
import { AddpartyComponent } from '../../party/addparty/addparty.component';
import { AddrawmaterialComponent } from '../../rawmaterial/addrawmaterial/addrawmaterial.component';

@Component({
  selector: 'app-addexpensedetail',
  templateUrl: './addexpensedetail.component.html',
  styleUrls: ['./addexpensedetail.component.css']
})
export class AddexpensedetailComponent implements OnInit {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;
  ispartyaddmode: boolean = false;
  rtnform: string = "";
  errtxt: any = "";

  expensedetailscoll: any = [];
  expenseBO: any = {}


  expensetypeColl: any = [];
  ismanualclose: boolean;

  isaccountaddmode: boolean = false;

  discounttype: string = "";

  productfindColl: any;
  taxColl: any;
  rawmaterialColl: any;
  isLoadingResult: boolean;
 
  partyColl: any = [];
  filterpaymentmodeid: number = 0;

  expenseform = new FormGroup({
    expensedetailsid: new FormControl(0),
    expenseid: new FormControl(0),
    rawmaterialid: new FormControl(0),
    rawmaterialname: new FormControl(null),
    qty: new FormControl(null, Validators.required),
    supplier: new FormControl(null, Validators.required),
    subtotal: new FormControl(null),
    descriptionid: new FormControl(null, Validators.required),
    amountid: new FormControl(null, Validators.required),
   
    nettotal: new FormControl(null),
    inactive: new FormControl(null),
  });


  formname: String = "ExpenseDetail";



  @Input() expensedetailsid: number = 0
  @Input() expenseid: number = 0
  @Input() ptype: String = "S";
  @Input() expensedetailsBO: any = {};

  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {

  }

  ngOnInit() {
    try {
      this.fnOnInitForm();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.expenseform.reset();
      this.fnInitializeForm();

      this.fnGetExpenseType();
      this.fnGetTax();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
    this.fnGetParty();
    this.fnGetExpenseType();
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }



  fnInitializeForm() {
    this.expenseform.setValue({
      expensedetailsid: this.expensedetailsBO.expensedetailsid,
      expenseid: this.expensedetailsBO.expenseid,
      rawmaterialid: this.expensedetailsBO.rawmaterialid,
      rawmaterialname: this.expensedetailsBO.rawmaterialname,
      qty: this.expensedetailsBO.qty,
      supplier: this.expensedetailsBO.supplier,
      subtotal: this.expensedetailsBO.subtotal,
      descriptionid: this.expensedetailsBO.descriptionid,
      amountid: this.expensedetailsBO.amountid,
      taxname: this.expensedetailsBO.taxname,
      taxrate: this.expensedetailsBO.taxrate,
      taxamt: this.expensedetailsBO.taxamt,
      cgsttaxrate: this.expensedetailsBO.cgsttaxrate,
      cgsttaxamt: this.expensedetailsBO.cgsttaxamt,
      sgsttaxrate: this.expensedetailsBO.sgsttaxrate,
      sgsttaxamt: this.expensedetailsBO.sgsttaxamt,
      igsttaxrate: this.expensedetailsBO.igsttaxrate,
      igsttaxamt: this.expensedetailsBO.igsttaxamt,
      taxable: this.expensedetailsBO.taxable,
      nettotal: this.expensedetailsBO.nettotal,
      inactive: false,
    })
  }




  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;
    var qty = this.expenseform.get('qty').value;
    if (this.loginService.fnCheckZeroDetcimal(qty) === 0) {
      this.errtxt = "Quantity is cannot be empty"
      this.expenseform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }


    // for (let row of this.purchasedetailscoll) {
    //   if (row.rawmaterialid > 0) {
    //     _detailscheck = true;
    //   }
    // }

    // if (!_detailscheck) {
    //   this.errtxt = "Purchase Details cannot be empty"
    //   this.expenseform.controls['inactive'].setErrors({ 'notfound': true });
    //   _ischeck = true;
    // }
    // if (!_ischeck) {
    //   for (let row of this.purchasedetailscoll) {

    //     if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
    //       this.errtxt = "Quantity is cannot be empty"
    //       this.expenseform.controls['inactive'].setErrors({ 'notfound': true });
    //       _ischeck = true;
    //     }

    //   }
    // }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.expenseform.get('inactive')) {
      this.expenseform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.expenseform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          expensedetailsid: this.expenseform.get('expensedetailsid').value,
          expenseid: this.expenseform.get('expenseid').value,
          rawmaterialid: this.expenseform.get('rawmaterialid').value,
          rawmaterialname: this.expenseform.get('rawmaterialname').value,
          qty: this.expenseform.get('qty').value,
          supplier: this.expenseform.get('supplier').value,
          subtotal: this.expenseform.get('subtotal').value,
          descriptionid: this.expenseform.get('descriptionid').value,
          amountid: this.expenseform.get('amountid').value,
          taxname: this.expenseform.get('taxname').value,
          taxrate: this.expenseform.get('taxrate').value,
          taxamt: this.expenseform.get('taxamt').value,
          cgsttaxrate: this.expenseform.get('cgsttaxrate').value,
          cgsttaxamt: this.expenseform.get('cgsttaxamt').value,
          sgsttaxrate: this.expenseform.get('sgsttaxrate').value,
          sgsttaxamt: this.expenseform.get('sgsttaxamt').value,
          igsttaxrate: this.expenseform.get('igsttaxrate').value,
          igsttaxamt: this.expenseform.get('igsttaxamt').value,
          taxable: this.expenseform.get('taxable').value,
          nettotal: this.expenseform.get('nettotal').value,
        }

        var result = {
          'checkstatus': 'DONE',
          'data': data
        }

        this.emitData.emit(result);
        this.activeModal.close(true);



      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }




  //Close
  async fnCloseForm() {

    try {


      var result = {
        'checkstatus': 'CANCEL',
        'data': null
      }

      this.emitData.emit(result);
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnGetParty() {
    var data = {
      'partyid': 0,
      'ptype': this.ptype,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {
          this.partyColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Details

  fnGetExpenseType() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getExpensetype(data)
      .subscribe(
        (res) => {
          this.expensetypeColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadExpenseType(index) {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),

    }
    this.appService.getExpensetype(data)
      .subscribe(
        (res) => {
          this.fnChangeExpenseType(index)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnChangeExpenseType(index) {

    var _expensetypename = "", _partyid = 0;

    for (let abo of this.expensetypeColl) {
      if (this.expensedetailscoll[index].rawmaterialid === abo.rawmaterialid) {
        _expensetypename = abo.expensetypename;
      }
    }
    this.expensedetailscoll[index].expensetypename = _expensetypename;
  }
  fnChangeParty(index) {

    var _partyname = "";

    for (let abo of this.partyColl) {
      if (this.expensedetailscoll[index].partyid === abo.partyid) {
        _partyname = abo.partyname;
      }
    }
    this.expensedetailscoll[index].partyname = _partyname;
  }

  fnGetTax() {
    this.isLoadingResult = true;

    var data = {
      'amountid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnCalcDetails() {

    var row = {
      expensedetailsid: this.expenseform.get('expensedetailsid').value,
      expenseid: this.expenseform.get('expenseid').value,
      rawmaterialid: this.expenseform.get('rawmaterialid').value,
      rawmaterialname: this.expenseform.get('rawmaterialname').value,
      qty: this.expenseform.get('qty').value,
      supplier: this.expenseform.get('supplier').value,
      subtotal: this.expenseform.get('subtotal').value,
      descriptionid: this.expenseform.get('descriptionid').value,
      amountid: this.expenseform.get('amountid').value,
      taxname: this.expenseform.get('taxname').value,
      taxrate: this.expenseform.get('taxrate').value,
      taxamt: this.expenseform.get('taxamt').value,
      cgsttaxrate: this.expenseform.get('cgsttaxrate').value,
      cgsttaxamt: this.expenseform.get('cgsttaxamt').value,
      sgsttaxrate: this.expenseform.get('sgsttaxrate').value,
      sgsttaxamt: this.expenseform.get('sgsttaxamt').value,
      igsttaxrate: this.expenseform.get('igsttaxrate').value,
      igsttaxamt: this.expenseform.get('igsttaxamt').value,
      taxable: this.expenseform.get('taxable').value,
      nettotal: this.expenseform.get('nettotal').value,
    }

    this.expensedetailsBO.subtotal = row.qty * row.supplier;

    this.expenseform.patchValue({ 'subtotal': this.expensedetailsBO.subtotal });
    //this.subtotal = this.subtotal + Number(row.subtotal)


    this.expensedetailsBO.taxamt = Number(this.fnConvertDecimal(this.expensedetailsBO.subtotal)) * Number(this.fnConvertDecimal(row.taxrate)) / 100
    this.expenseform.patchValue({ 'taxamt': this.expensedetailsBO.taxamt });

    //GST      
    this.expensedetailsBO.cgsttaxamt = Number(this.fnConvertDecimal(this.expensedetailsBO.taxamt)) / 2
    this.expensedetailsBO.sgsttaxamt = Number(this.fnConvertDecimal(this.expensedetailsBO.taxamt)) / 2
    this.expensedetailsBO.igsttaxamt = 0

    this.expenseform.patchValue({
      'cgsttaxamt': this.expensedetailsBO.cgsttaxamt,
      'sgsttaxamt': this.expensedetailsBO.sgsttaxamt,
      'igsttaxamt': this.expensedetailsBO.igsttaxamt
    })

    this.expensedetailsBO.taxable = Number(this.fnConvertDecimal(this.expensedetailsBO.subtotal));
    this.expenseform.patchValue({ 'taxable': this.expensedetailsBO.taxable });

    this.expensedetailsBO.nettotal = Number(this.fnConvertDecimal(this.expensedetailsBO.taxable)) + Number(this.fnConvertDecimal(this.expensedetailsBO.taxamt))
    this.expenseform.patchValue({ 'nettotal': this.expensedetailsBO.nettotal });
  }




  fnChangeRawmaterial() {

    var row = {
      rawmaterialid: this.expenseform.get('rawmaterialid').value,
    }

    var _prodname = "", _descriptionid = null, _supplier = 0, _amountid = null;

    for (let abo of this.rawmaterialColl) {
      if (row.rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _supplier = abo.purchaseprice;
        _descriptionid = abo.purchasedescriptionid;
        _amountid = abo.amountid;
      }
    }
    this.expensedetailsBO.rawmaterialname = _prodname;
    this.expensedetailsBO.supplier = _supplier;
    this.expensedetailsBO.descriptionid = _descriptionid;
    this.expensedetailsBO.amountid = _amountid;

    this.expenseform.patchValue({ 'rawmaterialname': this.expensedetailsBO.rawmaterialname });
    this.expenseform.patchValue({ 'supplier': this.expensedetailsBO.supplier });
    this.expenseform.patchValue({ 'description': this.expensedetailsBO.descriptionid });
    this.expenseform.patchValue({ 'amount': this.expensedetailsBO.amountid });

    // this.fnChangeTax()
  }



  //AddParty
  private fnAddParty() {

    const modalRef = this.productFindService.open(AddpartyComponent, { size: <any>'xxl' });
    modalRef.componentInstance.ptype = this.ptype

    if (modalRef.componentInstance.ptype === 'C') {
      modalRef.componentInstance.formname = 'Customer'
    }
    else if (modalRef.componentInstance.ptype === 'S') {
      modalRef.componentInstance.formname = 'Supplier'
    }
    modalRef.componentInstance.ngOnInit();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetParty();

      if (receivedEntry > 0) {
        this.expenseform.patchValue({ partyid: receivedEntry })
      }
    });

  }
  //AddProduct
  private fnAddExpenseType(index) {

    const modalRef = this.productFindService.open(AddexpensetypeComponent, { size: <any>'m' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetExpenseType();

      if (receivedEntry > 0) {
        this.expensedetailscoll[index].expensetypeid = receivedEntry
      }
      this.fnReLoadExpenseType(index);

    });
  }


  //AddProduct

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
